import { createActions, createReducer } from 'reduxsauce'

import DestinosItemService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDestinosItemInicio: [],
    buscaDestinosItemSucesso: ['destinosItem'],
    buscaDestinosItemErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDestinosItem = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDestinosItemInicio())
        let serv = new DestinosItemService()
        return serv
            .consultarDetalhesDestinoItem(filtro)
            .then(response => dispatch(Creators.buscaDestinosItemSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDestinosItemErro(error)))
    }
}

const buscaDestinosItemInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDestinosItemErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDestinosItemSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.destinosItem, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESTINOS_ITEM_INICIO]: buscaDestinosItemInicio,
    [Types.BUSCA_DESTINOS_ITEM_ERRO]: buscaDestinosItemErro,
    [Types.BUSCA_DESTINOS_ITEM_SUCESSO]: buscaDestinosItemSucesso,
})
